// export interface ApiListResponse<T> {
//     Data: T[];
//     PageInfo: {
//       CurrentPage: 2;
//       PageSize: 10;
//       TotalItems: 13;
//       HasNextPage: false;
//       NextPageUrl: null;
//     };
// }

import { z, ZodType } from "zod";

//zod schema where Data must be an array of schema T and PageInfo must be an object with the following properties

export const apiListSchema = <T>(dataType: ZodType<T>) =>
  z.object({
    Data: z.array(dataType),
    PageInfo: z.object({
      CurrentPage: z.number(),
      PageSize: z.number(),
      TotalItems: z.number(),
      HasNextPage: z.boolean(),
      NextPageUrl: z.string().nullable(),
    }),
  });
